module.exports = __webpack_public_path__ + "static/img/layout5.59d50ffb.jpg";